import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramCategory } from '../../models';

@Component({
  selector: 'lp-category-selection',
  templateUrl: './category-selection.component.html',
  styleUrls: ['./category-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategorySelectionComponent extends BaseResizableComponent {
  @Input() mainCategory?: LoyaltyProgramCategory;
  @Input() selectedCategory?: LoyaltyProgramCategory;
  @Output() selectedCategoryChange = new EventEmitter<LoyaltyProgramCategory>();

  onSelect(category?: LoyaltyProgramCategory) {
    this.selectedCategory = category;
    this.selectedCategoryChange.emit(category);
    this.cdr.markForCheck();
  }
}
